/**
 * mf-color-gallery-chrome.js
 * Narrow companion for unequal color-media-groups: sync slider chrome after
 * variantChange remount. Does NOT replace Dawn gallery / SliderComponent.
 * Loaded only when product.metafields.custom.color_media_groups is present.
 */
(function () {
  if (window.__mfColorGalleryChromeBound) return;
  window.__mfColorGalleryChromeBound = true;

  function galleryViewer() {
    return document.querySelector('media-gallery slider-component[id^="GalleryViewer-"]');
  }

  function syncChromeFromHtml(html) {
    const liveViewer = galleryViewer();
    if (!liveViewer) return;

    const liveButtons = liveViewer.querySelector('.slider-buttons');
    const liveSlider = liveViewer.slider || liveViewer.querySelector('[id^="Slider-"]');
    const liveCurrent = liveViewer.currentPageElement || liveViewer.querySelector('.slider-counter--current');
    const liveTotal = liveViewer.pageTotalElement || liveViewer.querySelector('.slider-counter--total');
    const livePrev = liveViewer.prevButton || liveViewer.querySelector('button[name="previous"]');
    const liveNext = liveViewer.nextButton || liveViewer.querySelector('button[name="next"]');

    // Prefer chrome from the freshly fetched section HTML when available.
    if (html && typeof html.querySelector === 'function') {
      const srcViewer = html.querySelector('media-gallery slider-component[id^="GalleryViewer-"]');
      const srcButtons = srcViewer && srcViewer.querySelector('.slider-buttons');
      if (liveButtons && srcButtons) {
        liveButtons.className = srcButtons.className;
      }
      const srcTotal = srcViewer && srcViewer.querySelector('.slider-counter--total');
      if (liveTotal && srcTotal) {
        liveTotal.textContent = srcTotal.textContent;
      }
      const srcCurrent = srcViewer && srcViewer.querySelector('.slider-counter--current');
      if (liveCurrent && srcCurrent) {
        liveCurrent.textContent = srcCurrent.textContent;
      }
    }

    if (liveSlider) {
      liveSlider.scrollLeft = 0;
    }

    // Refresh page math from CURRENT live slides only (never prior-color cache).
    if (typeof liveViewer.resetPages === 'function') {
      liveViewer.resetPages();
    }

    const slides = liveViewer.querySelectorAll('ul[id^="Slider-Gallery-"] > li[data-media-id], ul.product__media-list > li[data-media-id]');
    // Prefer visible slides (clientWidth > 0); fall back to DOM count after remount.
    let n = 0;
    slides.forEach((el) => {
      if (el.clientWidth > 0) n += 1;
    });
    if (n === 0) n = slides.length;

    if (n < 2) {
      // N=1: stock initPages early-returns without updating chrome — finish here.
      liveViewer.totalPages = 1;
      liveViewer.currentPage = 1;
      liveViewer.sliderItemsToShow = Array.from(slides);
      if (liveCurrent) liveCurrent.textContent = '1';
      if (liveTotal) liveTotal.textContent = String(Math.max(n, 1));
      if (liveButtons && !liveButtons.classList.contains('small-hide')) {
        liveButtons.classList.add('small-hide');
      }
      if (livePrev) livePrev.setAttribute('disabled', 'disabled');
      if (liveNext) liveNext.setAttribute('disabled', 'disabled');
      if (liveSlider) liveSlider.scrollLeft = 0;
    } else {
      // N≥2: ensure arrows visible; resetPages/initPages/update own disabled state.
      if (liveButtons) liveButtons.classList.remove('small-hide');
      if (liveTotal && (!liveTotal.textContent || liveTotal.textContent === '1')) {
        // If HTML copy missed, derive total from live count (current gallery only).
        liveTotal.textContent = String(n);
      }
      if (typeof liveViewer.resetPages === 'function') {
        liveViewer.resetPages();
      }
    }
  }

  function onVariantChange(event) {
    try {
      const html = event && event.data && event.data.html;
      // Defer one frame so remount + setActiveMedia settle first.
      requestAnimationFrame(() => {
        syncChromeFromHtml(html);
        // Second pass after layout (images / clientWidth).
        requestAnimationFrame(() => syncChromeFromHtml(html));
      });
    } catch (err) {
      // Never break PDP variant path.
      console.warn('[mf-color-gallery-chrome]', err);
    }
  }

  function bind() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
    // First-paint consistency (Liquid chrome should already match; soft sync).
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        requestAnimationFrame(() => syncChromeFromHtml(null));
      });
    } else {
      requestAnimationFrame(() => syncChromeFromHtml(null));
    }
  }

  bind();
})();
